import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Inject,
  Injectable,
  Injector,
} from '@angular/core';
import { BoschUiDialogComponent } from './bosch-ui-dialog.component';
import { BoschUiDialogConfigType } from './bosch-ui-dialog.model';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BoschUiDialog {
  get dialogRef(): ComponentRef<BoschUiDialogComponent> | null {
    return this._dialogRef;
  }
  get index(): number {
    return this._index;
  }

  private _dialogRef: ComponentRef<BoschUiDialogComponent> | null = null;
  private _index = 1000;

  hasTitle$ = new BehaviorSubject<boolean>(false);
  hasHeadline$ = new BehaviorSubject<boolean>(false);
  hasActions$ = new BehaviorSubject<boolean>(false);

  constructor(
    private injector: Injector,
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  open(component: unknown, config?: BoschUiDialogConfigType): void {
    const factory = this.componentFactoryResolver.resolveComponentFactory(BoschUiDialogComponent);
    const dialogRef = factory.create(this.injector);
    this._index += 1;

    dialogRef.instance.component = component;

    if (config) {
      dialogRef.instance.config = config;
    }

    this.appRef.attachView(dialogRef.hostView);
    const dialogDOMElement = (dialogRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
    this.document.body.appendChild(dialogDOMElement);
    this._dialogRef = dialogRef;
  }

  close(): void {
    if (this._dialogRef) {
      this._dialogRef.destroy();
      this.appRef.detachView(this._dialogRef.hostView);
      this._dialogRef = null;
    }
  }
}
